import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { Dump } from "../../../../../Dump";

import * as auto_pi from "@crochik/auto-pi";

interface PreviewFormProps {
  form: auto_pi.Form;
  raw?: object;
}

function EditForm({ form, raw }: PreviewFormProps) {
  return (
    <div>
      <Dump style={{ fontSize: "8pt" }} object={form} />
      {raw && <Dump style={{ fontSize: "8pt", color: "blue" }} object={raw} />}
    </div>
  );
}

interface IPreviewFormDialogProps extends PreviewFormProps {
  onClose: () => void;
}

export function PreviewFormDialog(props: IPreviewFormDialogProps) {
  const { onClose } = props;

  return (
    <Dialog open={true} fullScreen onClose={onClose}>
      <Button onClick={onClose}>Close</Button>
      <EditForm {...props} />
    </Dialog>
  );
}
